var arrLedger = [];
var convert = require('xml-js');


//get ledger names
function getLedgerNames(_this,meta) {
    if(meta=="electron"){
        window.api.send('getledgername-message'); 
        window.api.receive("getledgername-reply", (ledger_obj) => {
            _this.ledger_names = [];
            _this.ledger_names= ledger_obj;
        }); 
    }
    else{
        axios.get('fetchLedgerNames')
        .then((result) => {
            var ledger_obj = JSON.parse(convert.xml2json(result.data, { compact: true, spaces: 4 }));
            const ledger_val = ledger_obj.ENVELOPE.BODY.IMPORTDATA.REQUESTDATA.TALLYMESSAGE;
            var key = '';
            if (ledger_val.length > 0) {
                ledgerName(ledger_val, key, _this);
            }
            _this.ledger_names.items  = _this.arrLedger;
        })
    }
}

//resolve ledger json
function ledgerName(arr, key, _this) {
    if (arr) {
        arr.forEach(element => {
            if (Array.isArray(element) == true) {
                var Keys = '';
                ledgerName(element, Keys);
            }
            else if (typeof element == 'object') {
                //var values = Object.values(element);
                var vals = Object.keys(element).map(function (key) {
                    return element[key];
                });
                var keys = Object.keys(element);
                if (keys.includes("LEDGER") == true) {
                    // console.log(element.LEDGER._attributes.NAME);
                    _this.arrLedger.push(element.LEDGER._attributes.NAME)
                }
                else {
                    ledgerName(vals);
                }
            }
        });
    }
}
//get voucher type names
function getVoucherTypeNames(_this,meta) {
    if(meta == "electron"){
        window.api.send('getVoucherNames-message'); 
        window.api.receive("getVoucherNames-reply", (voucher_obj) => {
            _this.voucher_type_names = [];
            _this.voucher_type_names = voucher_obj;
        }); 
    }
    else{
        axios.get('fetchVoucherTypeNames')
        .then((result) => {
            var voucher_name_obj = JSON.parse(convert.xml2json(result.data, { compact: true, spaces: 4 }));
            const vouvher_name_val = voucher_name_obj.ENVELOPE.BODY.IMPORTDATA.REQUESTDATA.TALLYMESSAGE;
            var key = '';
            if (vouvher_name_val.length > 0) {
                vchTypeName(vouvher_name_val, key, _this);
            }
            _this.voucher_type_names = _this.arrVchType;
        })
    }
}

//resolve voucher type name
function vchTypeName(arr, key, _this) {
    if (arr) {
        arr.forEach(element => {
            if (Array.isArray(element) == true) {
                var Keys = '';
                vchTypeName(element, Keys);
            }
            else if (typeof element == 'object') {
                var keys = Object.keys(element);
                var vals = Object.keys(element).map(function (key) {
                    return element[key];
                });
                if (keys.includes("VOUCHERTYPE") == true) {
                    _this.arrVchType.push(element.VOUCHERTYPE._attributes.NAME)
                }
                else {
                    vchTypeName(vals);
                }
            }
        });
    }
}

//get voucher type parent name
function getVoucherTypeParentNames(_this,voucher_name,meta) {
    if(meta == "electron"){
        window.api.send('getVoucherParentNames-message',voucher_name); 
        window.api.receive("getVoucherParentNames-reply", (voucher_parent_name) => {
            $.each(_this.voucher_type_view, function (key, value) {
                if (voucher_parent_name == key) {
                _this.obj_view=value;
                _this.persisted_view=value;
                }
            })
        }); 
    }
    else{
        axios.get('fetchVoucherTypeParentNames')
            .then((result) => {
                var voucher_parent_obj = JSON.parse(convert.xml2json(result.data, { compact: true, spaces: 4 }));
                const voucher_parent_val = voucher_parent_obj.ENVELOPE.BODY.IMPORTDATA.REQUESTDATA.TALLYMESSAGE;
                var Keys = '';
                if (voucher_parent_val.length > 0) {
                    vchTypeParent(voucher_parent_val, Keys, voucher_name, _this);
                }
                $.each(_this.voucher_type_view, function (key, value) {
                    if (_this.VchParentType == key) {
                    _this.persisted_view=value;
                   
                    }
                })
            })
    }
}
//resolve vouchertypeparent name
function vchTypeParent(arr, key, val, _this) {
    if (arr) {
        arr.forEach(element => {
            if (Array.isArray(element) == true) {
                var Keys = '';
                vchTypeParent(element, Keys);
            }
            else if (typeof element == 'object') {
                var values = Object.values(element);
                var keys = Object.keys(element);
                if (keys.includes("VOUCHERTYPE") == true) {
                    if (element.VOUCHERTYPE._attributes.NAME == val) {
                        _this.VchParentType = element.VOUCHERTYPE.PARENT._text;
                    }
                }
                else {
                    vchTypeParent(values, keys);
                }
            }
        });
    }
}

export {getLedgerNames, getVoucherTypeNames,getVoucherTypeParentNames}